<template>
    <article>
        <b-button-group>
            <b-button @click="$refs.chooseModal.show()" variant="muted" size="sm">Choose File</b-button>
            <b-button @click="$refs.uploadModal.show()" variant="muted" size="sm">Upload File</b-button>
        </b-button-group>
        

        <b-modal ref='chooseModal' title="Choose File">
            <select-file-field @input="handleInput"/>
        </b-modal>

        <b-modal ref='uploadModal' title="Upload File">
            <upload-file-field
                :name="name"
                :readonly="readonly"
                :label="label"
                @input="handleInput"
            />
        </b-modal>
    </article>
</template>

<script>
    import axios from 'axios'
    import SelectFileField from './SelectFileField'
    import UploadFileField from './UploadFileField.vue'
    import field from '../../Mixins/field'

    export default {
        mixins: [field],
        components: {SelectFileField, UploadFileField},
        props: {
            name: {},
            label: {},
        },
        created() {
            this.$on('input', () => {
                this.$refs.chooseModal.hide()
                this.$refs.uploadModal.hide()
            })
        }
    }
</script>